import React from "react";
import {
  Box,
  Typography,
  Stack,
  styled,
  Grid,
} from "@mui/material";
import {
  Ticket as TicketIcon,
  Clock,
  CheckCircle2,
  Users,
  User as UserIcon
} from "lucide-react";

const GlassStatCard = styled(Box)(({ theme }) => ({
  background: 'white',
  borderRadius: '16px',
  padding: '12px 20px',
  border: '1px solid #F0F0F5',
  transition: 'all 0.3s ease',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  '&:hover': {
    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.06)',
    transform: 'translateY(-2px)'
  }
}));

const IconWrapper = styled(Box)(({ theme, color }) => ({
  backgroundColor: `${color}15`,
  color: color,
  padding: '6px',
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 'fit-content'
}));

export default function TicketCards({ cardDetails = [], stats = {} }) {
  const pending = (cardDetails.length || 0) - (stats.resolved || 0);

  const statItems = [
    {
      label: "Total Tickets",
      value: cardDetails.length || 0,
      icon: <TicketIcon size={20} />,
      color: '#6366F1'
    },
    {
      label: "Pending",
      value: pending > 0 ? pending : 0,
      icon: <Clock size={20} />,
      color: '#F97316'
    },
    {
      label: "Resolved",
      value: stats.resolved || 0,
      icon: <CheckCircle2 size={20} />,
      color: '#10B981'
    },
    {
      label: "Active Agents",
      value: stats.agents || 0,
      icon: <Users size={20} />,
      color: '#4F46E5'
    }
  ];

  return (
    <Grid container spacing={3} sx={{ mb: 4 }}>
      {statItems.map((item, idx) => (
        <Grid item xs={12} sm={6} md={3} key={idx} sx={{ display: 'flex' }}>
          <GlassStatCard>
            <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ width: '100%' }}>
              <Box>
                <Typography variant="caption" fontWeight={700} color="#6B7280" sx={{ letterSpacing: '0.5px', textTransform: 'uppercase', fontSize: '10px' }}>
                  {item.label}
                </Typography>
                <Typography variant="h5" fontWeight={800} sx={{ mt: 0.5, color: '#111827' }}>
                  {item.value}
                </Typography>
              </Box>
              <IconWrapper color={item.color} sx={{ mb: 0 }}>
                {item.icon}
              </IconWrapper>
            </Stack>
          </GlassStatCard>
        </Grid>
      ))}
    </Grid>
  );
}
